import { getFeatureToggle } from '@helsenorge/framework-utils/hn-feature-toggle';

export const sessionUpdaterEnabledToggle = () => getFeatureToggle('SessionUpdaterEnabled', 'Global');
